// v2.14 (owner 2026-10-22, requirement 75 butir 3): Sampah akun — pure helpers (no imports) so Jest
// can test them. The server decides every right; these only mirror it for the buttons and texts.

export const KARYAWAN_ROLES = ["kasir", "desain", "qc", "jahit", "pattern_layout", "op_sublim", "op_press",
  "op_dtf", "op_press_satuan", "op_press_roll", "op_outdoor_finishing", "op_digital"];

// May `me` move/restore account `u`? Owner: any account except the owner role and themselves;
// Manager: employee roles only (server: peran.cek_akun), never themselves.
export function bolehHapus(me, u) {
  if (!me || !u) return false;
  if (u.role === "admin" || u.id === me.id) return false;
  if (me.role === "admin") return true;
  if (me.role === "manager") return KARYAWAN_ROLES.includes(u.role);
  return false;
}

export function alasanValid(alasan) {
  return typeof alasan === "string" && alasan.trim().length >= 3;
}

// "pernah dipakai: nota 3, pembayaran 2, login" — from the server's jejak {collection: count}
const NAMA = { audit_logs: "audit log", notas: "nota", orders: "order", pembayaran: "pembayaran", kas: "buku kas",
  spks: "produksi", borongan_entri: "upah borongan", borongan_periode: "periode borongan", stok_mutasi: "mutasi stok",
  pembelian: "pembelian", pembayaran_supplier: "pembayaran supplier", pengembalian: "pengembalian",
  tv_pengumuman: "pengumuman layar", tv_kejadian: "kejadian layar", notifikasi: "notifikasi",
  push_langganan: "langganan notifikasi", login: "login", "sebelum v2.14": "akun dibuat sebelum v2.14" };

export function teksJejak(jejak) {
  const items = Object.entries(jejak || {});
  if (!items.length) return "belum pernah dipakai";
  return "pernah dipakai: " + items.map(([k, n]) => (k === "login" || k === "sebelum v2.14") ? (NAMA[k] || k) : `${NAMA[k] || k} ${n}`).join(", ");
}

// text under the Sampah row: "Dihapus 22/10/2026 oleh owner — alasan"
export function labelDihapus(row, fmtWaktu = (x) => x) {
  const d = row?.dihapus;
  if (!d) return "";
  return `Dihapus ${fmtWaktu(d.pada)} oleh ${d.oleh?.username || "-"} — ${d.alasan || ""}`;
}
